import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { ITagAddPayload, ITagUpdatePayload } from './taguri-proiecte.interface';

@Injectable({
    providedIn: 'root'
})
export class TaguriProiecteService {
    // private token!: string;
    // private httpOptions: any;

    private basePath = environment.interop.basePath;
    private listTaguriURL =
        this.basePath +
        environment.interop.monitoring.nomenclatoare.proiecteTag.list;
    private listDTTaguriURL =
        this.basePath +
        environment.interop.monitoring.nomenclatoare.proiecteTag.listDT;
    private addTagURL =
        this.basePath +
        environment.interop.monitoring.nomenclatoare.proiecteTag.store;
    private updateTagURL =
        this.basePath +
        environment.interop.monitoring.nomenclatoare.proiecteTag.update;
    private deleteTagURL =
        this.basePath +
        environment.interop.monitoring.nomenclatoare.proiecteTag.delete;
    private changeStatusActiveURL =
        this.basePath +
        environment.interop.monitoring.nomenclatoare.proiecteTag.changeActive;
    private listStatusActiveURL =
        this.basePath +
        environment.interop.monitoring.nomenclatoare.proiecteTag.listActive;

    constructor(private http: HttpClient) { }

    listTaguri() {
        return this.http.get(this.listTaguriURL);
    }

    listDTTaguri() {
        return this.http.post(this.listDTTaguriURL, {});
    }

    addTag(data: ITagAddPayload) {
        return this.http.post(this.addTagURL, data);
    }

    updateTag(data: ITagUpdatePayload) {
        return this.http.put(this.updateTagURL, data);
    }

    deleteTag(id: number) {
        return this.http.delete(this.deleteTagURL + id);
    }

    listStatusActive() {
        return this.http.get(this.listStatusActiveURL);
    }

    changeStatusActive(id: number) {
        return this.http.get(this.changeStatusActiveURL + id);
    }

    // setToken(token: string) {
    //     this.token = token;
    //     this.httpOptions = {
    //         headers: new HttpHeaders({
    //             'Content-Type': 'application/json',
    //             Accept: 'application/json',
    //             Authorization: `Bearer ${this.token}`,
    //         }),
    //     };
    // }
}
